/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React, {FunctionComponent} from "react";
import {Field} from "redux-form";
import {noValidation, required} from "../../../utils/my-puratos/FormUtils";

interface IProps {
    name: string,
    label?: string,
    disabled?: boolean,
    isRequired?: boolean,
    hasError?: boolean,
}

export const CheckboxField: FunctionComponent<IProps> = ({name, label, disabled = false, isRequired = false, hasError = false}) => {

    return <Field name={name} component={CheckBoxInput} label={label} disabled={disabled} required={isRequired}
                  hasError={hasError} validate={isRequired ? required : noValidation}/>;

};

const CheckBoxInput = ({input, meta, label, disabled, required, hasError, ...props}) => {
    const error = required && ((hasError && !meta.valid) || (meta.touched && !meta.valid));
    const html = required ? "<span>*</span> " + label : label;

    return (
        <div className="row">
            <div className={`col-md-6 col-sm-12 form--input__checkbox ${error ? "form--input__error" : ""}`}>
                <div className={"p-checkbox-13"}>
                    <input name={input.name} id={input.name} type="checkbox" checked={input.value} required={required}
                           disabled={disabled} {...input} {...props}/>
                    <label htmlFor={input.name} dangerouslySetInnerHTML={{__html: html}}/>
                </div>
            </div>
        </div>
    );

}
